import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const benefits = ['Un avatar definido (voz + límites + promesa clara)', 'Reglas de estilo (para que te reconozcan)', 'Una biblioteca de escenas (para no empezar desde cero)', '10 guiones listos (para publicar sin pensar)', 'Un plan de producción en lote (para sacar 7–14 piezas)', 'Un calendario simple de 14 días (para sostener el personaje)'];
export function BenefitsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4" data-id="element-1">
      <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 50
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-3">
          Lo que vas a tener{' '}
          <span className="text-cyan-400" data-id="element-4">al final de 7 días</span>
        </h2>

        <div className="space-y-6" data-id="element-5">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -20
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start bg-zinc-900/30 border border-cyan-500/10 rounded-lg p-6" data-id="element-6">
              <CheckIcon className="w-6 h-6 text-cyan-400 mr-4 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-7" />
              <span className="text-lg text-gray-200 leading-relaxed" data-id="element-8">
                {benefit}
              </span>
            </motion.div>)}
        </div>

        {/* Who it's for / not for */}
        <div className="grid md:grid-cols-2 gap-8 mt-16" data-id="element-9">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          delay: 0.7,
          duration: 0.5
        }} className="bg-zinc-900/50 border border-cyan-500/20 rounded-lg p-6" data-id="element-10">
            <h3 className="text-xl font-bold text-cyan-400 mb-4" data-id="element-11">
              ¿Para quién es esto?
            </h3>
            <p className="text-gray-300 leading-relaxed" data-id="element-12">
              Para hispanohablantes en USA que: necesitan ingresos/ventas y no
              quieren perder tiempo, no quieren (o no pueden) salir en cámara,
              quieren un plan ejecutable en una semana, prefieren claridad y
              estructura, no motivación.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          delay: 0.9,
          duration: 0.5
        }} className="bg-zinc-900/50 border border-red-500/20 rounded-lg p-6" data-id="element-13">
            <h3 className="text-xl font-bold text-red-400 mb-4" data-id="element-14">
              ¿Para quién NO es?
            </h3>
            <ul className="space-y-2 text-gray-300" data-id="element-15">
              <li data-id="element-16">• Si buscas magia, no es aquí.</li>
              <li data-id="element-17">• Si quieres cambiar de nicho cada 3 días, no es aquí.</li>
              <li data-id="element-18">
                • Si quieres perfección estética antes de publicar, no es aquí.
              </li>
            </ul>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}